import React from "react";
import { LineShareButton } from "react-share";
import { Box, Image } from "@chakra-ui/react";
import { COMMON_WEB_PATH } from "../../constant";
import useWebsiteInfo from "../../hook/useWebsiteInfo";

const LineShare = () => {
  const shareUrl = "https://911vip.tw/";
  const { images } = useWebsiteInfo();

  return (
    <Box as="div" display="inline-block">
      <LineShareButton url={shareUrl}>
        <Image
          src={images.lineSHARE}
          alt="分享到Line"
          boxSize={{ base: "60px", md: "70px" }}
          objectFit="contain"
          cursor="pointer"
          transition="transform 0.2s"
          _hover={{ transform: "scale(1.05)" }}
        />
      </LineShareButton>
    </Box>
  );
};

export default LineShare;
